import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import DownloadIcon from '@material-ui/icons/CloudDownload'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import SamplingsProduct from 'components/SamplingsProduct'
import headerImg from 'images/samplings/header-samplings.png'
import React from 'react'
import { Page, Toolbar } from 'react-onsenui'
import { appBar, filters } from '../Styles'
const SamplingsScreen = props => {
  const data = props.samplingsData

  return (
    <Page
      renderToolbar={() => (
        <Toolbar className={props.classes.appBar}>
          <div className="left">
            <KeyboardArrowLeftIcon onClick={() => props.goBack()} className={props.classes.goBackIcon} />
          </div>
          <div className="center">
            <Typography className={props.classes.title}>Clasificaciones</Typography>
          </div>
          <div className="right">
            <Hidden xsDown>
              <DownloadIcon className={props.classes.goBackIcon} onClick={props.downloadSamplingsCsv} />
            </Hidden>
          </div>
        </Toolbar>
      )}>
      <div className={props.classes.header}>
        <div className={props.classes.header1}>
          <div>
            <div className={props.classes.sampledTotalsContainer}>
              <Typography className={props.classes.sampledTotalsLabel}>Clasificado</Typography>
              <div className={props.classes.sampledTotals}>
                <Grid container>
                  {!data ? (
                    <Grid item xs={12}>
                      <CircularProgress color="secondary" size={29} />
                    </Grid>
                  ) : (
                    <React.Fragment>
                      <Grid item xs={6}>
                        <Typography className={props.classes.sampledTotalLeft}>
                          {data.kgSampledGlobal.toLocaleString(undefined, { maximumFractionDigits: 2 }) + ' kg.'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography className={props.classes.sampledTotalRight}>
                          {data.eurosSampledGlobal.toLocaleString(undefined, { maximumFractionDigits: 2 }) + ' €'}
                        </Typography>
                      </Grid>
                    </React.Fragment>
                  )}
                </Grid>
              </div>
            </div>
            <Grid container>
              <Grid item xs={6}>
                <Typography className={props.classes.pendingSampled}>
                  <div className={props.classes.pendingSampledLabel}>Pendiente clasificar</div>
                  <div className={props.classes.pendingSampledValue}>
                    {(data ? data.kgPendingGlobal.toLocaleString(undefined, { maximumFractionDigits: 2 }) : '--') +
                      ' kg.'}
                  </div>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={props.classes.pendingSampled}>
                  <div className={props.classes.pendingSampledLabel}>Pendiente liquidar</div>
                  <div className={props.classes.pendingSampledValue}>
                    {(data ? data.eurosPendingGlobal.toLocaleString(undefined, { maximumFractionDigits: 2 }) : '--') +
                      ' €'}
                  </div>
                </Typography>
              </Grid>

            </Grid>
            {/* <Typography variant="display1" className={props.classes.totalKg}>
              {
                (!data || props.loading) ? (
                  <CircularProgress color="secondary" />
                ) : (
                  data.netWeightGlobal.toLocaleString() + ' kg.'
                )
              }
            </Typography> */}
          </div>
        </div>
        <Grid container direction="column">
          <Grid item container className={props.classes.filters}>
            <Grid item xs={4} onClick={props.openDateModal}>
              <Typography className={props.classes.filterName}>
                Periodo
                <KeyboardArrowDownIcon className={props.classes.icon} />
              </Typography>
              <Typography
                className={props.classes.filterValue}
                dangerouslySetInnerHTML={{ __html: props.periodLabel }}
              />
            </Grid>
            <Grid item xs={4} onClick={props.openGreenhousesModal}>
              <Typography className={props.classes.filterName}>
                Naves
                <KeyboardArrowDownIcon className={props.classes.icon} />
              </Typography>
              <Typography className={props.classes.filterValue}>
                {props.selectedGreenhouses.length ? `${props.selectedGreenhouses.length} seleccionadas` : 'Todas'}
              </Typography>
            </Grid>

            <Grid item xs={4} onClick={props.openFarmerModal}>
              <Typography className={props.classes.filterName}>
                Agricultor
                <KeyboardArrowDownIcon className={props.classes.icon} />
              </Typography>
              <Typography className={props.classes.filterValue}>
                {props.selectedFarmers.length ? `${props.selectedFarmers.length} seleccionadas` : 'Todas'}
              </Typography>
            </Grid>

          </Grid>
        </Grid>
      </div>
      <Grid container className={props.classes.products}>
        {data &&
          data.samplings &&
          data.samplings.map((data, idx) => (
            <SamplingsProduct
              key={'sp' + idx}
              data={data}
              onSelectEntryProduct={props.onSelectEntryProduct}
              onSelectSamplingProduct={props.onSelectSamplingProduct}
            />
          ))}
      </Grid>
    </Page>
  )
}

const styles = {
  appBar,
  icon: {
    fontSize: 20,
    verticalAlign: 'middle',
  },
  header: {
    backgroundImage: `url('${headerImg}')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  header1: {
    padding: 10,
  },
  goBackIcon: {
    cursor: 'pointer',
    padding: 7,
    fontSize: 30,
    color: 'white',
  },
  title: {
    padding: 10,
    fontWeight: 600,
    fontSize: 17,
    color: 'white',
    textAlign: 'center',
  },
  sampledTotalsContainer: {
    margin: '5px 0 10px',
    textAlign: 'center',
  },
  sampledTotalsLabel: {
    display: 'inline-block',
    background: 'white',
    fontSize: 18,
    padding: '0 12px',
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
  },
  sampledTotals: {
    border: '2px solid white',
    borderRadius: 5,
    padding: '7px 10px',
  },
  sampledTotalLeft: {
    color: 'white',
    textAlign: 'center',
    fontSize: 22,
    borderRight: '2px solid white',
  },
  sampledTotalRight: {
    color: 'white',
    textAlign: 'center',
    fontSize: 22,
  },
  pendingSampled: {
    textAlign: 'center',
    color: 'white',
  },
  pendingSampledLabel: {
    fontSize: 15,
    fontWeight: 300,
  },
  pendingSampledValue: {
    marginTop: 5,
    fontSize: 22,
    fontWeight: 400,
  },
  filters: {
    marginTop: 5,
    padding: 7,
    ...filters,
  },
  filterName: {
    color: 'white',
    textAlign: 'center',
    fontWeight: 300,
    fontSize: 13,
    cursor: 'pointer',
  },
  filterValue: {
    marginTop: -3,
    color: 'white',
    textAlign: 'center',
    fontWeight: 400,
    fontSize: 15,
    cursor: 'pointer',
  },
  products: {},
}

export default withStyles(styles)(SamplingsScreen)



// WEBPACK FOOTER //
// ./src/screens/SamplingsScreen.js